<template>
    <div class="leftbar-tab-menu">
        <IconsBar :confirmViews="confirmViews" @openMenu="openMenuOf"/>
        <MenuBar :activeMenu="activeMenu"/>
    </div>
</template>

<script>
    import IconsBar from './IconsBar';
    import MenuBar from './MenuBar';

    export default {
        name: 'LeftBar',
        components: {MenuBar, IconsBar},
        props: {
            confirmView: Boolean
        },
        data() {
            return {
                activeMenu: null,
                confirmViews: null
            };
        },
        created() {
            this.confirmViews = this.confirmView;
        },
        methods: {
            openMenuOf(menuName, val) {
                this.activeMenu = menuName;
                this.$emit('enlargeMenu', val);
            }
        }
    };
</script>

<style scoped>

</style>
